/**
 * Slide-out cart
 * Floating button + panel from the right, auto-open on add to cart
 */
(function () {
    'use strict';

    const SELECTORS = {
        cart: '#slide-cart',
        trigger: '#slide-cart-trigger',
        overlay: '#slide-cart-overlay',
        panel: '#slide-cart-panel',
        body: '#slide-cart-body',
        close: '.slide-cart__close',
        remove: '.slide-cart__item-remove',
    };

    const CLASSES = {
        open: 'slide-cart--open',
        hasItems: 'slide-cart--has-items',
        empty: 'slide-cart--empty',
    };

    function getCart() {
        return document.querySelector(SELECTORS.cart);
    }

    function getTrigger() {
        return document.querySelector(SELECTORS.trigger);
    }

    function getOverlay() {
        return document.querySelector(SELECTORS.overlay);
    }

    function getPanel() {
        return document.querySelector(SELECTORS.panel);
    }

    function isOpen() {
        const cart = getCart();
        return cart && cart.classList.contains(CLASSES.open);
    }

    function open() {
        const cart = getCart();
        const trigger = getTrigger();
        const panel = getPanel();
        const overlay = getOverlay();
        if (!cart || !panel || !overlay) return;

        cart.classList.add(CLASSES.open);
        cart.setAttribute('aria-hidden', 'false');
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
            if (!cart.classList.contains(CLASSES.empty)) {
                trigger.removeAttribute('tabindex');
            }
        }
        panel.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }

    function close() {
        const cart = getCart();
        const trigger = getTrigger();
        const panel = getPanel();
        const overlay = getOverlay();
        if (!cart || !panel || !overlay) return;

        cart.classList.remove(CLASSES.open);
        panel.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-hidden', 'true');
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
        }
        document.body.style.overflow = '';
        updateFromFragments();
    }

    function toggle() {
        if (isOpen()) {
            close();
        } else {
            open();
        }
    }

    function updateFromFragments() {
        const cart = getCart();
        const trigger = getTrigger();
        if (!cart || !trigger) return;

        const hasCount = trigger.querySelector('.slide-cart__count');
        if (hasCount) {
            cart.classList.add(CLASSES.hasItems);
            cart.classList.remove(CLASSES.empty);
            trigger.removeAttribute('tabindex');
        } else {
            cart.classList.remove(CLASSES.hasItems);
            cart.classList.add(CLASSES.empty);
            trigger.setAttribute('tabindex', '-1');
        }

        if (isOpen()) {
            cart.setAttribute('aria-hidden', 'false');
            trigger.setAttribute('aria-expanded', 'true');
            const panel = getPanel();
            const overlay = getOverlay();
            if (panel) panel.setAttribute('aria-hidden', 'false');
            if (overlay) overlay.setAttribute('aria-hidden', 'false');
        } else if (hasCount) {
            cart.setAttribute('aria-hidden', 'false');
        } else {
            cart.setAttribute('aria-hidden', 'true');
        }
    }

    function getAjaxUrl(endpoint) {
        const cfg = window.bpSlideCart || {};
        const wcParams = window.wc_add_to_cart_params || {};
        const template = cfg.ajaxUrl || wcParams.wc_ajax_url || '/?wc-ajax=%%endpoint%%';
        return template.replace('%%endpoint%%', endpoint);
    }

    function applyFragments(fragments) {
        if (!fragments) return;
        if (window.jQuery) {
            window.jQuery.each(fragments, function (selector, html) {
                window.jQuery(selector).replaceWith(html);
            });
            return;
        }
        Object.keys(fragments).forEach(function (selector) {
            const el = document.querySelector(selector);
            if (!el) return;
            const tmp = document.createElement('div');
            tmp.innerHTML = String(fragments[selector]).trim();
            const next = tmp.firstElementChild;
            if (next) {
                el.replaceWith(next);
            }
        });
    }

    function refreshAfterCartChange(fragments) {
        const keepOpen = isOpen();
        applyFragments(fragments);
        updateFromFragments();
        if (keepOpen) {
            open();
        }
    }

    function removeCartItem(btn) {
        const key = btn.getAttribute('data-cart_item_key');
        if (!key || btn.classList.contains('is-removing')) return;

        btn.classList.add('is-removing');
        btn.disabled = true;
        const item = btn.closest('.slide-cart__item');
        if (item) item.classList.add('is-removing');

        const body = new URLSearchParams();
        body.append('cart_item_key', key);

        fetch(getAjaxUrl('remove_from_cart'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: body.toString(),
        })
            .then(function (res) {
                return res.json();
            })
            .then(function (data) {
                if (!data || !data.fragments) {
                    throw new Error('remove_failed');
                }
                refreshAfterCartChange(data.fragments);
                document.body.dispatchEvent(new CustomEvent('removed_from_cart', {
                    detail: { fragments: data.fragments, cart_hash: data.cart_hash },
                }));
                document.body.dispatchEvent(new CustomEvent('wc_fragments_refreshed'));
                if (window.jQuery) {
                    window.jQuery(document.body).trigger('removed_from_cart', [data.fragments, data.cart_hash, window.jQuery(btn)]);
                    window.jQuery(document.body).trigger('wc_fragments_refreshed');
                }
            })
            .catch(function () {
                btn.classList.remove('is-removing');
                btn.disabled = false;
                if (item) item.classList.remove('is-removing');
            });
    }

    function bindEvents() {
        const cart = getCart();
        if (!cart) return;

        document.addEventListener('click', function (e) {
            const trigger = e.target.closest(SELECTORS.trigger);
            if (trigger) {
                e.preventDefault();
                if (getCart() && getCart().classList.contains(CLASSES.empty) && !isOpen()) return;
                toggle();
                return;
            }

            const overlay = e.target.closest(SELECTORS.overlay);
            if (overlay && getCart() && getCart().contains(overlay)) {
                close();
                return;
            }

            const closeBtn = e.target.closest(SELECTORS.close);
            if (closeBtn && getCart() && getCart().contains(closeBtn)) {
                close();
                return;
            }

            const removeBtn = e.target.closest(SELECTORS.remove);
            if (removeBtn && getCart() && getCart().contains(removeBtn)) {
                e.preventDefault();
                e.stopPropagation();
                removeCartItem(removeBtn);
            }
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && isOpen()) {
                close();
            }
        });

        cart.addEventListener('transitionend', function (e) {
            if (e.target === getPanel() && e.propertyName === 'transform') {
                if (!isOpen()) {
                    document.body.style.overflow = '';
                }
            }
        });
    }

    function init() {
        const cart = getCart();
        if (!cart) return;

        bindEvents();

        // Shop loops fire this through jQuery. A native listener never hears it,
        // so the panel stayed closed and WooCommerce left a "View cart" link.
        // Product pages also dispatch the native event.
        function onAddedToCart() {
            setTimeout(function () {
                document.querySelectorAll('a.added_to_cart').forEach(function (link) {
                    link.remove();
                });
                updateFromFragments();
                open();
            }, 50);
        }
        document.body.addEventListener('added_to_cart', onAddedToCart);
        if (window.jQuery) {
            window.jQuery(document.body).on('added_to_cart.bpSlideCart', onAddedToCart);
        }

        document.body.addEventListener('removed_from_cart', function () {
            setTimeout(function () {
                const keepOpen = isOpen();
                updateFromFragments();
                if (keepOpen) {
                    open();
                }
            }, 50);
        });

        document.body.addEventListener('wc_fragments_refreshed', function () {
            updateFromFragments();
            if (isOpen()) {
                open();
            }
        });

        document.body.addEventListener('wc_fragments_loaded', function () {
            updateFromFragments();
            if (isOpen()) {
                open();
            }
        });

        const params = new URLSearchParams(window.location.search);
        const shouldOpen = params.has('add-to-cart') || params.has('added_to_cart') || params.has('slide_cart_open');
        if (shouldOpen) {
            const cleanUrl = new URL(window.location.href);
            cleanUrl.searchParams.delete('add-to-cart');
            cleanUrl.searchParams.delete('added_to_cart');
            cleanUrl.searchParams.delete('slide_cart_open');
            if (window.history && window.history.replaceState) {
                window.history.replaceState({}, document.title, cleanUrl.toString());
            }
            setTimeout(function () {
                updateFromFragments();
                if (getCart() && (getCart().classList.contains(CLASSES.hasItems) || params.has('add-to-cart') || params.has('slide_cart_open'))) {
                    open();
                }
            }, 300);
        }

        document.body.addEventListener('click', function (e) {
            const headerCart = e.target.closest('.header-action--cart');
            if (headerCart && getCart() && !getCart().classList.contains(CLASSES.empty)) {
                e.preventDefault();
                open();
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
